import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,

   
    
}

const mutations={
   
    
    
    
    getWalletData(state,val){
        

     
        post(urls.admin.wallet.index,val).then((result)=>{
          
          
          
          state.result=result
          
       
       
        
       
           
        });
        
    },
   
    
    rechargeWalletUserData(state,val){
        

     
        post(urls.admin.wallet.recharge,val).then((result)=>{
          
          
          
          state.result=result
          
       
       
        
       
           
        });
        
    },
   
}
const  actions={
    getWalletDataAction(context,value){
        
        context.commit("getWalletData",value)
       
    },

    rechargeWalletUserDataAction(context,value){
        
        context.commit("rechargeWalletUserData",value)
       
    }
    
  
   
    
   
  
    
  
    
   

}

export default {state,mutations,actions}